import React, { useState, useEffect } from "react";

import "./sidemenu.css";
import contentFile from "../../constants/contentFile.json";
import { useNavigate, useLocation } from "react-router-dom";
import ToggleArrow from "../../assets/images/Toggle-arrow.svg";

const Sidemenu = () => {
  const menuList = contentFile.sidemenu;
  const navigate = useNavigate();
  const location = useLocation();

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const [acitveItem, setActiveItem] = useState(location.pathname);
  const [collapseActive, setCollapseActive] = useState(false);
  const [previousPath, setPreviousPath] = useState(""); // Store previous path

  useEffect(() => {
    setPreviousPath(acitveItem); // Store the last active path before updating
    setActiveItem(location.pathname);
  }, [location.pathname]);

  const sidemenuCollapse = (e) => {
    setCollapseActive(!collapseActive);
  };

  const filteredMenuList = menuList.filter((menu) => {
    // Always show the Dashboard
    // if (menu.label === "Dashboard") return true;

    if (!menu.featureId) return true; // Show menu without a featureId
    const permission = permissions.find((p) => p.feature === menu.featureId);
    return permission?.view === true; // Show if view is true
  });

  useEffect(() => {
    const activeMenu = menuList.find((menu) =>
      location.pathname.startsWith(menu.path)
    );
    setActiveItem(activeMenu?.path || ""); // Set the active menu path
  }, [location.pathname, menuList]);

  return (
    <div className="sidemenu-page">
      <nav id="sidebar" class={collapseActive ? "active" : ""}>
        <ul class="list-unstyled components">
          {filteredMenuList.map((menu, index) => {
            return (
              <li
                className={acitveItem === menu.path ? "active-item" : ""}
                key={index}
                onClick={() => {
                  setActiveItem(menu.path);
                  navigate(menu.path);
                }}
              >
                <i className={menu.className}></i>
                <span>{menu.label}</span>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidemenu;
